import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getNotifications(companyId, query) {
  return dataTransferWrap(
    ModulesMap.NOTIFICATIONS,dtConfig[ModulesMap.NOTIFICATIONS].getNotifications,
    {
      urlParams: {
        companyId,
      },
      params: query,
    },
  )
}

function patchNotificationsMarkAllRead(companyId, body) {
  return dataTransferWrap(
    ModulesMap.NOTIFICATIONS,dtConfig[ModulesMap.NOTIFICATIONS].patchNotificationsMarkAllRead,
    {
      urlParams: {
        companyId,
      },
      ...body,
    })
}

function patchNotificationsMarkReadStatus(companyId, body) {
  return dataTransferWrap(
    ModulesMap.NOTIFICATIONS,dtConfig[ModulesMap.NOTIFICATIONS].patchNotificationsMarkReadStatus,
    {
      urlParams: {
        companyId,
      },
      ...body,
    })
}

function getNotificationsUnreadCount(companyId, query, cashedPayload) {
  return dataTransferWrap(
    ModulesMap.NOTIFICATIONS,dtConfig[ModulesMap.NOTIFICATIONS].getNotificationsUnreadCount,
    {
      urlParams: {
        companyId,
      },
      params: query,
    },
    cashedPayload
  )
}

function getNotification(companyId, notificationId) {
  return dataTransferWrap(
    ModulesMap.NOTIFICATIONS,dtConfig[ModulesMap.NOTIFICATIONS].getNotification,
    {
      urlParams: {
        companyId,
        notificationId,
      },
    },
  )
}

function patchNotifications(companyId, notificationId, body) {
  return dataTransferWrap(
    ModulesMap.NOTIFICATIONS,dtConfig[ModulesMap.NOTIFICATIONS].patchNotifications,
    {
      urlParams: {
        companyId,
        notificationId,
      },
      ...body,
    })
}

function getNotificationPreview(companyId, notificationId) {
  return dataTransferWrap(
    ModulesMap.NOTIFICATIONS,dtConfig[ModulesMap.NOTIFICATIONS].getNotificationPreview,
    {
      urlParams: {
        companyId,
        notificationId,
      },
    },
  )
}

function getNotificationsSettings(companyId) {
  return dataTransferWrap(
    ModulesMap.NOTIFICATIONS,dtConfig[ModulesMap.NOTIFICATIONS].getNotificationsSettings,
    {
      urlParams: {
        companyId,
      },
    },
  )
}

function patchNotificationsSettings(companyId, notificationSettingId, body) {
  return dataTransferWrap(
    ModulesMap.NOTIFICATIONS,dtConfig[ModulesMap.NOTIFICATIONS].patchNotificationsSettings,
    {
      urlParams: {
        companyId,
        notificationSettingId
      },
      ...body,
    })
}

export default {
  getNotifications,
  patchNotificationsMarkAllRead,
  patchNotificationsMarkReadStatus,
  getNotificationsUnreadCount,
  getNotification,
  patchNotifications,
  getNotificationPreview,
  getNotificationsSettings,
  patchNotificationsSettings,
}